'use client';
import { Link, Stack, Typography } from '@zeus/core';
import { FormattedMessage } from 'react-intl';
import { BrokenSuitcase } from '../broken-suitcase/BrokenSuitcase';
import { StyledButton } from '../styled-button/StyledButton';
import { Image as SVGImage } from './Image';

export interface SignedOutErrorProps {
  signInUrl: string;
  image?: 'default' | 'brokensuitcase';
}

export const SignedOutError: React.FC<SignedOutErrorProps> = ({
  signInUrl,
  image = 'default',
}) => (
  <Stack alignItems="center" spacing={2}>
    {image === 'brokensuitcase' ? <BrokenSuitcase /> : <SVGImage />}
    <Typography variant="h5" color="text.primary">
      <SignBackIn />
    </Typography>

    <Typography
      variant="body1"
      color="text.primary"
      sx={{ maxWidth: 550, textAlign: 'center' }}
    >
      <SignBackInDescription />
    </Typography>
    <Link href={signInUrl + '?from-session-timeout=true'} target="_self">
      <StyledButton variant="contained">
        <SignIn />
      </StyledButton>
    </Link>
  </Stack>
);

const SignBackIn = () => (
  <FormattedMessage
    id="shared-ui.signed-out-error.sign-back-in"
    defaultMessage="Sign back in to continue"
  />
);

const SignBackInDescription = () => (
  <FormattedMessage
    id="shared-ui.signed-out-error.sign-back-in-description"
    defaultMessage="You either signed out or your session expired. Please sign in again to see your business account."
  />
);

const SignIn = () => (
  <FormattedMessage
    id="shared-ui.signed-out-error.sign-in"
    defaultMessage="Sign in"
  />
);
